(function(){
  'use strict';

  // Accordion: one filter group open at a time (clicking the open group
  // closes it). Brand renders first and is the only group open by default.
  window.mhToggleGroup = function(titleEl) {
    var g = titleEl.closest('.mh-filter-group');
    var wasOpen = !g.classList.contains('collapsed');
    document.querySelectorAll('#mh-sidebar .mh-filter-group').forEach(function (x) { x.classList.add('collapsed'); });
    if (!wasOpen) g.classList.remove('collapsed');
  };

  // On load, if a non-Brand group carries an active selection (came back
  // from a filtered URL), open that group instead so the applied filter is
  // visible; otherwise Brand stays open per the default markup.
  (function () {
    var groups = document.querySelectorAll('#mh-sidebar .mh-filter-group');
    if (!groups.length) return;
    var active = null;
    groups.forEach(function (g) {
      if (active) return;
      if (g.querySelector('input[type=checkbox]:checked')) { active = g; return; }
      if (g.getAttribute('data-group') === 'price') {
        var mn = g.querySelector('#mh-price-min'), mx = g.querySelector('#mh-price-max');
        if ((mn && mn.value) || (mx && mx.value)) active = g;
      }
    });
    if (active && active.classList.contains('collapsed')) {
      groups.forEach(function (g) { g.classList.add('collapsed'); });
      active.classList.remove('collapsed');
    }
    // Collections without a Brand filter (e.g. /collections/all, where
    // Shopify exposes no storefront filters) would otherwise load with
    // every group collapsed — open the first one instead.
    var anyOpen = false;
    groups.forEach(function (g) { if (!g.classList.contains('collapsed')) anyOpen = true; });
    if (!anyOpen) groups[0].classList.remove('collapsed');
  })();

  // ── Category attribute filters (Size / Colour / RAM …) ─────────────
  // Admin-defined per category in the middleware; values are mhf-* product
  // tags toggled through the same path-URL mechanism as Deals/PayLater.
  (function () {
    var mount = document.getElementById('mh-attr-filters');
    if (!mount) return;
    var handle = mount.getAttribute('data-collection-handle') || '';
    var lang = mount.getAttribute('data-lang') || 'en';
    if (!handle) return;
    var activeTags = mhCurrentTagsFromPath();

    function chevronSvg() {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('width', '12'); s.setAttribute('height', '12');
      s.setAttribute('viewBox', '0 0 12 12'); s.setAttribute('fill', 'currentColor');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', 'M6 4L1 9h10z');
      s.appendChild(p);
      return s;
    }

    fetch('https://admin.menahub.com/api/collection_filters.php?handle=' + encodeURIComponent(handle) + '&lang=' + encodeURIComponent(lang))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.success || !d.groups || !d.groups.length) return;
        d.groups.forEach(function (g) {
          var hasActive = g.values.some(function (v) { return activeTags.indexOf(v.tag) !== -1; });
          var box = document.createElement('div');
          box.className = 'mh-filter-group' + (hasActive ? '' : ' collapsed');
          box.setAttribute('data-group', 'attr-' + g.code);

          var title = document.createElement('div');
          title.className = 'mh-filter-group-title';
          title.appendChild(document.createTextNode(g.name));
          title.appendChild(chevronSvg());
          title.addEventListener('click', function () { window.mhToggleGroup(title); });
          box.appendChild(title);

          var body = document.createElement('div');
          body.className = 'mh-filter-group-body';
          g.values.forEach(function (v) {
            var lab = document.createElement('label');
            lab.className = 'mh-filter-item';
            var cb = document.createElement('input');
            cb.type = 'checkbox';
            cb.setAttribute('data-mh-tag', v.tag);
            cb.checked = activeTags.indexOf(v.tag) !== -1;
            cb.addEventListener('click', function (e) { e.preventDefault(); window.mhToggleTag(cb); });
            var wrap = document.createElement('span');
            wrap.className = 'mh-brand-label-wrap';
            var nm = document.createElement('span');
            nm.className = 'brand-name';
            nm.textContent = v.label;
            var cn = document.createElement('span');
            cn.className = 'brand-count';
            cn.textContent = String(v.count);
            wrap.appendChild(nm); wrap.appendChild(cn);
            lab.appendChild(cb); lab.appendChild(wrap);
            body.appendChild(lab);
          });
          box.appendChild(body);
          mount.appendChild(box);
        });
      })
      .catch(function () {});
  })();

  // Read the collection root URL stamped on the form by Liquid.
  // Falls back gracefully if the form isn't on the page (e.g. mobile-no-filter).
  function mhCollectionUrl() {
    var f = document.getElementById('mh-filter-form');
    return (f && f.dataset.mhCollectionUrl) || window.location.pathname.split('/').slice(0, 3).join('/');
  }

  // Parse "/collections/handle/sale+express-delivery" -> ["sale","express-delivery"].
  function mhCurrentTagsFromPath() {
    var base = mhCollectionUrl().replace(/\/$/, '');
    var path = window.location.pathname.replace(/\/$/, '');
    if (path === base) return [];
    if (path.indexOf(base + '/') !== 0) return [];
    var rest = path.substring(base.length + 1);
    return rest.split('+').filter(Boolean).map(decodeURIComponent);
  }

  // Toggle a single tag in the legacy path-based URL pattern.
  // Path-based URLs work without any Search & Discovery admin config and
  // populate Liquid `current_tags` so the checkbox `checked` state is
  // correct on the next page load.
  function mhBuildTagUrl(tags) {
    var url = mhCollectionUrl().replace(/\/$/, '');
    if (tags.length > 0) url += '/' + tags.map(encodeURIComponent).join('+');
    var params = new URLSearchParams(window.location.search);
    params.delete('filter.p.tag');
    params.delete('page');
    var qs = params.toString();
    return url + (qs ? '?' + qs : '');
  }

  // Show shimmer skeleton over the product grid while page navigates.
  // Replaces the old full-screen circle spinner overlay.
  function mhShowShimmerLoading() {
    var shimmer = document.getElementById('mh-shimmer-grid');
    var prodGrid = document.getElementById('mh-product-grid');

    // Close mobile sidebar so the user can actually see the shimmer underneath
    var sidebar = document.getElementById('mh-sidebar');
    if (sidebar && sidebar.classList.contains('mobile-open')) {
      sidebar.classList.remove('mobile-open');
      var overlay = document.getElementById('mh-sidebar-overlay');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (prodGrid) prodGrid.style.opacity = '0';
    if (shimmer) {
      shimmer.style.display = 'grid';
      shimmer.classList.remove('hidden');
      // Scroll the shimmer into view if user is scrolled below the products area
      var rect = shimmer.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight - 120) {
        var top = rect.top + window.pageYOffset - 80;
        window.scrollTo(0, Math.max(0, top));
      }
    }
  }

  // Wait two animation frames so the shimmer actually paints before we
  // hand control back to the browser to navigate. Without this, fast
  // synchronous navigations skip the paint entirely.
  function mhAfterPaint(fn) {
    requestAnimationFrame(function(){
      requestAnimationFrame(fn);
    });
  }

  window.mhToggleTag = function(checkbox) {
    var tag = checkbox.dataset.mhTag;
    if (!tag) return;
    var tags = mhCurrentTagsFromPath();
    var idx = tags.indexOf(tag);
    if (idx >= 0) tags.splice(idx, 1);
    else tags.push(tag);
    mhShowShimmerLoading();
    mhAfterPaint(function(){ window.location.href = mhBuildTagUrl(tags); });
  };

  window.mhRemoveTag = function(tag) {
    var tags = mhCurrentTagsFromPath().filter(function(t) { return t !== tag; });
    mhShowShimmerLoading();
    mhAfterPaint(function(){ window.location.href = mhBuildTagUrl(tags); });
  };

  window.mhFilterChanged = function(input) {
    mhShowShimmerLoading();
    // Disable empty inputs before submit to keep URLs clean
    var form = document.getElementById('mh-filter-form');
    form.querySelectorAll('input, select').forEach(function(el) {
      if (!el.value || el.value === '' || (el.type === 'checkbox' && !el.checked)) {
        el.disabled = true;
      }
    });
    // Re-enable the changed input
    input.disabled = false;
    mhAfterPaint(function(){ form.submit(); });
  };

  window.mhApplyPrice = function() {
    mhShowShimmerLoading();
    var form = document.getElementById('mh-filter-form');
    // Disable empty fields
    form.querySelectorAll('input:not([type=number]), select').forEach(function(el) {
      if (!el.value || (el.type === 'checkbox' && !el.checked)) {
        el.disabled = true;
      }
    });
    // Disable empty price inputs
    var minP = document.getElementById('mh-price-min');
    var maxP = document.getElementById('mh-price-max');
    if (minP && !minP.value) minP.disabled = true;
    if (maxP && !maxP.value) maxP.disabled = true;
    mhAfterPaint(function(){ form.submit(); });
  };

  window.mhSort = function(select) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.set('page', '1');
    mhShowShimmerLoading();
    mhAfterPaint(function(){ window.location.href = url.toString(); });
  };

  window.mhSortTab = function(btn, sortValue) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.set('page', '1');
    mhShowShimmerLoading();
    mhAfterPaint(function(){ window.location.href = url.toString(); });
  };

  window.mhSetView = function(type, btn) {
    var grid = document.getElementById('mh-product-grid');
    if (!grid) return;
    grid.classList.remove('list-view');
    document.getElementById('mh-grid-btn').classList.remove('active');
    document.getElementById('mh-list-btn').classList.remove('active');
    if (type === 'list') grid.classList.add('list-view');
    btn.classList.add('active');
    localStorage.setItem('mh_view', type);
  };

  window.mhToggleMobileSidebar = function() {
    var s = document.getElementById('mh-sidebar');
    var o = document.getElementById('mh-sidebar-overlay');
    if (!s) return;
    var isOpen = s.classList.contains('mobile-open');
    if (isOpen) {
      s.classList.remove('mobile-open');
      if (o) o.classList.remove('active');
      document.body.style.overflow = '';
    } else {
      s.classList.add('mobile-open');
      if (o) o.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  };

  window.mhBrandSearch = function(input) {
    var q = input.value.toLowerCase();
    input.closest('.mh-filter-group-body').querySelectorAll('.mh-brand-item').forEach(function(item) {
      var nameEl = item.querySelector('.brand-name');
      var label = nameEl ? nameEl.textContent.toLowerCase() : '';
      item.style.display = label.includes(q) ? '' : 'none';
    });
  };

  window.mhExpandFilter = function(link, e) {
    e.preventDefault();
    link.closest('.mh-filter-group-body').querySelectorAll('.mh-filter-item[style*="display:none"]').forEach(function(el){ el.style.display=''; });
    link.remove();
  };

  /* ---- Numbered pagination replaced infinite scroll on 2026-07-09.
         Removed: IntersectionObserver trigger, mhLoadNextPage two-phase fetch
         chain, mhSeen dedupe map, endMsg reveal. Reason: every fetched page
         appended to the grid caused visible layout jerk (OOS-tail relocation,
         document-height jumps, label/carousel re-hydration). Real pagination
         = one page per navigation, no in-page reflow. */
  var grid = document.getElementById('mh-product-grid');

  /* ---- SORT OUT-OF-STOCK LAST ----
     Each card exposes data-available ("true"/"false") from product-card-new
     (price 0 counts as out of stock). Move every OOS card to the end of the
     grid so in-stock items always come first. appendChild() on an existing
     child just relocates it, so this is idempotent and safe to re-run after
     every infinite-scroll page append. */
  /* Move every out-of-stock card to the END of the same grid (appendChild on
     an existing child just relocates it — idempotent). Runs once while the
     grid is still hidden, so there's no visible jump. */
  function mhFlushOOS() { mhSortOOSLast(); }
  function mhSortOOSLast() {
    var g = document.getElementById('mh-product-grid');
    if (!g) return;
    var oos = g.querySelectorAll(':scope > [data-available="false"]');
    for (var i = 0; i < oos.length; i++) { g.appendChild(oos[i]); }
  }

  /* ---- SHIMMER → REVEAL ---- */
  function mhRevealGrid() {
    mhSortOOSLast(); /* reorder while still hidden → no visible jump */
    var shimmer = document.getElementById('mh-shimmer-grid');
    var prodGrid = document.getElementById('mh-product-grid');
    if (prodGrid) prodGrid.style.opacity = '1';
    if (shimmer) {
      shimmer.classList.add('hidden');
      setTimeout(function(){ shimmer.style.display = 'none'; }, 350);
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    var tags = document.querySelectorAll('.mh-active-tag');
    if (tags.length > 0) {
      var cb = document.getElementById('mh-clear-all');
      if (cb) cb.classList.add('visible');
    }
    var saved = localStorage.getItem('mh_view');
    if (saved === 'list') {
      var g = document.getElementById('mh-product-grid');
      var lb = document.getElementById('mh-list-btn');
      var gb = document.getElementById('mh-grid-btn');
      if (g) g.classList.add('list-view');
      if (lb) lb.classList.add('active');
      if (gb) gb.classList.remove('active');
    }
    /* Reveal products after images start loading */
    var imgs = document.querySelectorAll('#mh-product-grid img');
    if (imgs.length === 0) { mhRevealGrid(); return; }
    var loaded = 0;
    var firstBatch = Math.min(imgs.length, 4);
    function onImgReady() {
      loaded++;
      if (loaded >= firstBatch) mhRevealGrid();
    }
    for (var i = 0; i < firstBatch; i++) {
      if (imgs[i].complete) { onImgReady(); }
      else {
        imgs[i].addEventListener('load', onImgReady);
        imgs[i].addEventListener('error', onImgReady);
      }
    }
    /* Fallback: reveal after 2s max */
    setTimeout(mhRevealGrid, 2000);
  });

  /* Back/forward-cache restore: pages are snapshotted at the moment the user
     navigates away — which, after a sort/filter/tag click (or a language
     switch), is WITH the shimmer showing and the grid hidden, because
     mhShowShimmerLoading() runs right before those navigations. None of the
     load-time reveal triggers re-fire on a bfcache restore, so the shimmer
     animated forever over an already-loaded grid. pageshow always fires on
     restores — reveal unconditionally (idempotent). */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) mhRevealGrid();
  });
})();
